import MainLayout from 'src/components/layout/MainLayout';

type ActionsLayoutProps = {
    children: React.ReactNode;
};

const ActionsLayout = ({ children }: ActionsLayoutProps) => {
    return (
        <>
            {/* <TabRow>
                <Tab to="/actions" end>
                    {formatMessage(actionMessages.allActions)}
                </Tab>
                <Tab to="/actions/customise">{formatMessage(actionMessages.customiseQuickActions)}</Tab>
            </TabRow> */}
            <MainLayout>{children}</MainLayout>
        </>
    );
};

export default ActionsLayout;
